import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NJDocData, DOData, NJDocDefTemplate } from '../DOData'
import { DocDefPrimLibService } from '../../doc-def-prim-lib.service';
@Component({
    selector: 'cylib-doimage',
    templateUrl: './doimage.component.html',
    styleUrls: ['./doimage.component.css']
})
export class DoimageComponent implements OnInit {

    constructor(private data: DocDefPrimLibService) { }

    @Input() DocDefTemplate: NJDocDefTemplate
    @Input() customParameters: NJDocDefTemplate
    @Output() clickImage: EventEmitter<DOData> =
        new EventEmitter<DOData>();
    @Input() DocData: NJDocData;
    lblDocDefTemplate: NJDocDefTemplate
    Styles: any;
    Class: any;
    url: string = ""
    ngOnInit() {
    }
    ngOnChanges(): void {
        this.lblDocDefTemplate = this.DocDefTemplate;
        if (this.lblDocDefTemplate.tLabel.length == 0) {
            this.lblDocDefTemplate.tLabel = "|"
        }
        if (this.customParameters['LabelBlank'] == "Yes") {
            this.lblDocDefTemplate.tLabel = ""
        }
        if (this.customParameters['Styles'] != null) {
            let styles = this.data.replaceAll(this.customParameters['Styles'], "'", '"');
            this.Styles = JSON.parse(styles);
        }
        if (this.customParameters['Class'] != null) {
            this.Class = this.data.replaceAll(this.customParameters['Class'], "'", '"');
        } else {
            this.Class = "col-md-12 col-sm-12";
        }
        let src = this.customParameters['src'];
        this.url = this.data.apiBaseName + src;
    }
    onDoImageClick(event: any) {
        let DOMessage: DOData = new DOData();
        DOMessage.njDocData = this.DocData;
        DOMessage.njDocDefTemplate = this.DocDefTemplate;
        this.clickImage.emit(DOMessage);

    }

}